import React from "react";

export default function TermsPage() {
  return (
    <div data-testid="terms-page" className="min-h-screen bg-ff-bg pt-24 md:pt-32 pb-24">
      <div className="max-w-3xl mx-auto px-4 md:px-6">
        <p className="label text-ff-accent mb-4">LEGAL</p>
        <h1 className="font-serif text-display text-ff-text mb-8">Terms of Service</h1>
        <p className="text-ff-text-muted text-sm mb-12">Last updated: February 2026</p>

        <div className="prose-legal space-y-8 text-ff-text-muted text-sm leading-relaxed">

          <section>
            <h2 className="font-serif text-lg text-ff-text mb-3">1. Agreement to Terms</h2>
            <p>By accessing or using the Freddy Fiction website ("Site"), operated by Freddy Media ("we," "us," or "our"), you agree to be bound by these Terms of Service ("Terms"). If you do not agree to these Terms, you may not access or use the Site.</p>
          </section>

          <section>
            <h2 className="font-serif text-lg text-ff-text mb-3">2. Description of Service</h2>
            <p>Freddy Fiction is a serialized fiction publishing platform that provides original literary content in episodic format. We offer free access to select stories and paid subscription tiers that provide additional features, including weekly chapter email delivery and early access to new releases.</p>
          </section>

          <section>
            <h2 className="font-serif text-lg text-ff-text mb-3">3. Subscription Tiers</h2>
            <p>We offer the following subscription plans:</p>
            <ul className="list-disc list-inside mt-2 space-y-1">
              <li><strong className="text-ff-text">Free:</strong> Access to all currently published stories on the website.</li>
              <li><strong className="text-ff-text">Reader ($5/month):</strong> Includes free-tier access plus weekly chapter email delivery for active series.</li>
              <li><strong className="text-ff-text">Patron ($9.99/month):</strong> Includes all Reader benefits plus immediate access to new stories as they are published.</li>
            </ul>
            <p className="mt-2">Paid subscriptions are billed monthly through Stripe. You may cancel your subscription at any time. Cancellation takes effect at the end of your current billing cycle.</p>
          </section>

          <section>
            <h2 className="font-serif text-lg text-ff-text mb-3">4. Content Ownership</h2>
            <p>All stories, text, illustrations, and other creative content published on Freddy Fiction are the intellectual property of Freddy Media and its contributing authors. You may not reproduce, distribute, modify, create derivative works of, publicly display, or commercially exploit any content without prior written consent.</p>
          </section>

          <section>
            <h2 className="font-serif text-lg text-ff-text mb-3">5. User Conduct</h2>
            <p>You agree not to:</p>
            <ul className="list-disc list-inside mt-2 space-y-1">
              <li>Copy, redistribute, or republish any story content</li>
              <li>Use automated systems (bots, scrapers) to access the Site</li>
              <li>Attempt to circumvent subscription or access controls</li>
              <li>Share subscription credentials with others</li>
              <li>Engage in any conduct that disrupts the service for others</li>
            </ul>
          </section>

          <section>
            <h2 className="font-serif text-lg text-ff-text mb-3">6. Account Termination</h2>
            <p>We reserve the right to suspend or terminate your account and access to the Site at our sole discretion, without notice, for conduct that we determine violates these Terms or is harmful to other users, us, or third parties.</p>
          </section>

          <section>
            <h2 className="font-serif text-lg text-ff-text mb-3">7. Payment & Refunds</h2>
            <p>Payments are processed securely through Stripe. We do not store your payment card information. Subscription fees are non-refundable except as required by applicable law. If you believe you have been charged in error, please contact us within 30 days.</p>
          </section>

          <section>
            <h2 className="font-serif text-lg text-ff-text mb-3">8. Disclaimer of Warranties</h2>
            <p>The Site and its content are provided "as is" and "as available" without warranties of any kind, either express or implied. We do not guarantee that the Site will be uninterrupted, secure, or error-free.</p>
          </section>

          <section>
            <h2 className="font-serif text-lg text-ff-text mb-3">9. Limitation of Liability</h2>
            <p>To the fullest extent permitted by law, Freddy Media shall not be liable for any indirect, incidental, special, consequential, or punitive damages arising from your use of the Site or any content therein.</p>
          </section>

          <section>
            <h2 className="font-serif text-lg text-ff-text mb-3">10. Changes to Terms</h2>
            <p>We may update these Terms from time to time. We will notify subscribers of material changes via email. Your continued use of the Site after changes are posted constitutes your acceptance of the revised Terms.</p>
          </section>

          <section>
            <h2 className="font-serif text-lg text-ff-text mb-3">11. Contact</h2>
            <p>For questions about these Terms, please contact us at <a href="mailto:legal@freddyfiction.com" className="text-ff-accent hover:underline">legal@freddyfiction.com</a>.</p>
          </section>
        </div>
      </div>
    </div>
  );
}
